<div *ngIf="booking && showPartners && algunAMostrar" class="card"
    [ngClass]="mode">
    <span class="title d-block">{{ 'PARTNER.TITLE' | translate }}</span>
    <div *ngIf="mode=='write'" class="selectors">
        <div *ngFor="let partnersCategory of partners | keyvalue: sortCategories">
            <div *ngFor="let partner of partnersCategory.value">
                <entity-selector [searchBeforeFocus]="true" (hasResults)="hasPartners(partner, $event)"
                *ngIf="partner.showPartnerOnScreen && partner.partnerIsMine && !partner.inheritedPartner" [(ngModel)]="partner.partnerId"
                    (valuechangefunction)="setPartner(partner.partnerId, partner.oldPartnerId, partner.partnerCategory)" [entitySelector]="'Partner'"
                    [fixedFilterKeys]="partner.filters"
                    placeholder="{{ partner.resource | translate }}"
                    [readonly]="readonly || partner.inheritedPartner || partner.blockedPartner">
                </entity-selector>
            </div>
        </div>

        <button class="link d-block"
            (click)="mode = 'read'">{{ 'BOOKINGPAGE.PARTNERSELECTOR.CANCEL.CAPTION' | translate }}</button>
    </div>
    <div *ngIf="mode=='read'" class="info-partners-list cards">
        <div *ngFor="let partnersCategory of partners | keyvalue: sortCategories">
            <div *ngFor="let partner of partnersCategory.value">
                <shared-partner-infocard class="partner.type" [ngClass]="{'disabled' : !partner.partnerIsMine, 'inherited' : partner.inheritedPartner }" [type]="partner.type" [partnerId]="partner.partnerId"
                *ngIf="partner.showPartnerOnScreen && partner.partnerId && partner.partnerIsMine"
                [caption]="partner.resource"></shared-partner-infocard>
            </div>
        </div>

        <button class="link d-block" *ngIf="booking.isModifiable"
            (click)="mode = 'write'">{{ 'BOOKINGPAGE.PARTNERSELECTOR.CHANGE.CAPTION' | translate }}</button>
    </div>
</div>